import React, { useEffect, useState } from "react";

// DevExtreme components
import RadioGroup from 'devextreme-react/radio-group';

// Component styles
import classes from "./RadiogroupWidget.module.scss";

const EMPTY = null;

export function RadiogroupWidget(props) {
  const { ui, data, config, writeBack } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let content = localContent !== EMPTY ? localContent : data && data.content ? JSON.parse(data.content) : null;
  let currentValue = content ? content.CurrentItemId : null;
  let selectionCandidates = (content ? content.SelectionCandidates : null) || (config ? config.SelectionCandidates : null);
  let verticalLayout = config ? config.VerticalOrientation === true : false;
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    console.log("RadiogroupWidget data of " + ui.id + ": ", data);
  }, [data]);

  const setContent = (args) => {
    let value = args.value;
    setLocalContent({ CurrentItemId: value });
    writeBack(value, true);
  };

  return (
    <RadioGroup
      id={widgetId}
      className={classes.group}
      layout={verticalLayout ? "vertical" : "horizontal"}
      items={selectionCandidates}
      displayExpr="DisplayData"
      valueExpr="ItemId"
      value={currentValue}
      onValueChanged={setContent}
      disabled={disabled}
    />
  );
}